<nz-result
  nzStatus="warning"
  [nzTitle]=" 'common.label.notFound' | translate "
  [nzSubTitle]=" 'common.msg.notFound' | translate ">
  <div nz-result-extra>
    <button
      nz-button
      (click)="goToMainPage()"
      nzType="primary">
        {{ 'common.btn.toMainPage' | translate }}
    </button>
  </div>
</nz-result>
